import { CloseCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton = ({ to = undefined }) => {
    const navigate = useNavigate();

    const toRoute = () => {
        if (!to) {
            navigate(-1);
            return;
        }
        navigate(to);
    };

    return (
        <Button
            style={{
                background: "#c92f2f",
                color: "white",
            }}
            icon={<CloseCircleOutlined />}
            onClick={toRoute}
        >
            Cancel
        </Button>
    );
};

export default BackButton;
